import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'terms' | 'privacy'>(null);
  return <>
      <footer className="py-12 px-6 bg-charcoal text-cream/60 text-center text-sm" data-id="element-43">
        <div className="max-w-4xl mx-auto" data-id="element-44">
          <p className="mb-4" data-id="element-45">
            Este producto no sustituye el consejo médico profesional. Los
            resultados pueden variar.
          </p>
          <div className="flex justify-center gap-6 mb-6" data-id="element-46">
            <button onClick={() => setOpenModal('terms')} className="hover:text-cream transition-colors underline-offset-4 hover:underline" data-id="element-47">
              Términos y Condiciones
            </button>
            <button onClick={() => setOpenModal('privacy')} className="hover:text-cream transition-colors underline-offset-4 hover:underline" data-id="element-48">
              Política de Privacidad
            </button>
          </div>
          <p data-id="element-49">
            © {new Date().getFullYear()} El Reset Metabólico 40+. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-50">
        <p className="text-sm text-charcoal/60" data-id="element-51">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-52">
          1. Aceptación de los Términos
        </h4>
        <p data-id="element-53">
          Al adquirir el producto digital "El Reset Metabólico 40+" usted acepta
          en su totalidad estos Términos y Condiciones. Si no está de acuerdo
          con alguno de ellos, le solicitamos no completar la compra.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-54">
          2. Descripción del Producto
        </h4>
        <p data-id="element-55">
          El producto consiste en un audiolibro digital, un protocolo de 14
          días, una guía de nutrición anti-cortisol y un audio bonus. Todo el
          contenido es de carácter informativo y educativo. El acceso es
          inmediato tras la confirmación del pago.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-56">
          3. Aviso Médico
        </h4>
        <p data-id="element-57">
          Este producto no constituye consejo médico, diagnóstico ni
          tratamiento. La información presentada no sustituye la consulta con un
          profesional de la salud. Antes de iniciar cualquier protocolo de
          alimentación o estilo de vida, le recomendamos consultar con su
          médico, especialmente si padece alguna condición preexistente.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-58">
          4. Licencia de Uso
        </h4>
        <p data-id="element-59">
          Al comprar, usted recibe una licencia personal, no exclusiva e
          intransferible para acceder y utilizar el contenido. Está prohibido
          copiar, redistribuir, revender o compartir los materiales sin
          autorización expresa por escrito.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-60">
          5. Resultados
        </h4>
        <p data-id="element-61">
          Los testimonios y resultados mencionados son referenciales. Los
          resultados pueden variar de una persona a otra y dependen de factores
          individuales como compromiso, condiciones de salud y consistencia en
          la aplicación del protocolo. No garantizamos resultados específicos.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-62">
          6. Política de Reembolso
        </h4>
        <p data-id="element-63">
          Por tratarse de un producto digital de acceso inmediato, las ventas
          son finales. Cualquier solicitud de reembolso será evaluada conforme a
          la política vigente en la plataforma de procesamiento de pagos.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-64">
          7. Propiedad Intelectual
        </h4>
        <p data-id="element-65">
          Todo el contenido, marcas, textos, audios y materiales gráficos son
          propiedad exclusiva de "El Reset Metabólico 40+" y están protegidos
          por las leyes de propiedad intelectual aplicables.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-66">
          8. Modificaciones
        </h4>
        <p data-id="element-67">
          Nos reservamos el derecho de modificar estos Términos y Condiciones en
          cualquier momento. Las modificaciones entrarán en vigor desde su
          publicación en este sitio.
        </p>
      </Modal>

      {/* Privacy Policy Modal */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-68">
        <p className="text-sm text-charcoal/60" data-id="element-69">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-70">
          1. Información que Recopilamos
        </h4>
        <p data-id="element-71">
          Recopilamos únicamente los datos necesarios para procesar su compra y
          entregarle el producto digital. Esto incluye: nombre, dirección de
          correo electrónico e información de pago procesada de forma segura por
          nuestra plataforma de cobro.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-72">
          2. Uso de la Información
        </h4>
        <p data-id="element-73">
          Sus datos son utilizados exclusivamente para: (i) procesar su pago,
          (ii) entregar el acceso a los materiales digitales adquiridos, (iii)
          enviarle comunicaciones relacionadas con su compra, y (iv) cumplir con
          las obligaciones legales aplicables.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-74">
          3. Protección de Datos
        </h4>
        <p data-id="element-75">
          Implementamos medidas técnicas y organizativas razonables para
          proteger su información personal contra acceso no autorizado,
          alteración o destrucción. Su información de pago se procesa
          directamente a través de proveedores certificados y nunca se almacena
          en nuestros servidores.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-76">
          4. Compartir Información
        </h4>
        <p data-id="element-77">
          No vendemos, alquilamos ni intercambiamos su información personal con
          terceros. Únicamente compartimos datos con proveedores estrictamente
          necesarios para la operación del servicio (procesadores de pago y
          plataformas de entrega de contenido).
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-78">
          5. Cookies y Tecnologías Similares
        </h4>
        <p data-id="element-79">
          Este sitio puede utilizar cookies y tecnologías similares para mejorar
          la experiencia de navegación, analizar el tráfico y personalizar el
          contenido. Usted puede configurar su navegador para rechazar las
          cookies si así lo desea.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-80">
          6. Sus Derechos
        </h4>
        <p data-id="element-81">
          Usted tiene derecho a acceder, rectificar, eliminar y oponerse al
          tratamiento de sus datos personales, así como a la portabilidad de los
          mismos, conforme a la legislación de protección de datos aplicable.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-82">
          7. Retención de Datos
        </h4>
        <p data-id="element-83">
          Conservamos su información personal solo durante el tiempo necesario
          para cumplir con los fines descritos en esta política o según lo
          requiera la ley aplicable.
        </p>

        <h4 className="font-serif text-lg text-charcoal font-semibold pt-2" data-id="element-84">
          8. Cambios en esta Política
        </h4>
        <p data-id="element-85">
          Podemos actualizar esta Política de Privacidad periódicamente.
          Cualquier cambio será publicado en esta misma página con la fecha de
          actualización correspondiente.
        </p>
      </Modal>
    </>;
}